import { DonationCategoryDetailsDlg } from './donationCategory/donationCategory-details-dlg.cmp';
import { ModalService } from '../components/modal/modal.svc';
import { MatDialog } from '@angular/material/dialog';
import { MatAccordion } from '@angular/material/expansion';
import { MatSelect } from '@angular/material/select';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { DonationCategoriesData } from './donationCategories.data';

import { Component, OnInit, ViewChild, Input, } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ServicesData } from '../services/services.data';
import { Router } from '@angular/router';
//import { AutoCompleteComponent } from '../components/‏‏auto-complete/auto-complete.cmp';
import { ToraxHttp } from '../utils/custom-http.svc';
import { DonationCategory } from './donationCategory/donationCategory';
import { AutoCompleteComponent } from '../components/‏‏auto-complete/auto-complete.cmp';
import { IndexService } from '../services/index-service';
import { SubscriptionLike } from 'rxjs';

@Component({
	selector: 'donationCategories-list',
	templateUrl: 'donationCategories-list.tmpl.html'
})

export class DonationCategoriesList implements OnInit {

	constructor(
		private donationCategoriesData: DonationCategoriesData,
		private formBuilder: FormBuilder,
		public servicesData: ServicesData,
		private router: Router,
		public _matDialog: MatDialog,
    private toraxHttp: ToraxHttp
	  ) {
      let sub = this.toraxHttp!.updatedEvent.subscribe(i => {
        if (this.indexService && i.type.indexOf('/donationCategories') > -1) {
          this.indexService.getList();
        }
      });
      this.subscriptions.push(sub);
    }

    subscriptions: SubscriptionLike[] = [];
    ngOnDestroy() {
      this.subscriptions.forEach(s => s.unsubscribe());
    }


    indexService: IndexService;
  addNew() {
    this.router.navigate(['', { outlets: { popup: ['donationCategories', 'add'] } }]);
  }


	displayedColumns: string[] = ['buttons', 'keyNumber', 'donationCategoryID', 'title', 'openDate', 'isIncludeRecord'];
	data: any[] = [];

	resultsLength = 0;
	isRateLimitReached = false;

	@ViewChild(MatAccordion, { static: true }) accordion: MatAccordion;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild('donationCategoryID') donationCategoryID: AutoCompleteComponent;


	searchDonationCategoriesListForm: FormGroup;
	sourceList;
	pageRows = 20;
	rowsCount;
	page;

	public clerFilter() {
		this.initForm();
		this.getDonationCategories();
	}

	// addNew() {
	// 	this.router.navigate([{ outlets: { popup: ['add'] } }]);
	// }

	openSelectedRow(donationCategoryID) {
		this.router.navigate(['', { outlets: { popup: ['donationCategories', donationCategoryID] } }]);
	}
	openDetails(row: DonationCategory) {
		this._matDialog.open(DonationCategoryDetailsDlg, {
			data: row
		});
	}


	public downloadExcel() {
		if(!this.searchDonationCategoriesListForm.controls.donationCategoryTypes.value){
			alert('יש לבחור סוג רשומה לפני ייצוא');
			return;
		}
			this.donationCategoriesData.downloadExcel(this.searchDonationCategoriesListForm.value)
			.subscribe(blob => {
				let link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = `קטגוריות סטנציה.xlsx`;
				link.click();
			});
	}

	public downloadHeavyExcel() {
		if(!this.searchDonationCategoriesListForm.controls.donationCategoryTypes.value){
			alert('יש לבחור סוג רשומה לפני ייצוא');
			return;
		}
		this.donationCategoriesData.downloadHeavyExcel(this.searchDonationCategoriesListForm.value)
			.subscribe(blob => {
				let link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = `קטגוריות סטנציה מלא.xlsx`;
				link.click();
			});
	}

	public getDonationCategories() {
		sessionStorage.setItem(this.router.url, JSON.stringify(this.searchDonationCategoriesListForm.value));

		return this.donationCategoriesData!.getList(this.searchDonationCategoriesListForm.value)
			.subscribe((data: any) => {
				this.data = data;
				this.sourceList = data.list;
				this.page = data.list.length;
				this.pageRows = data.list.length;
				this.rowsCount = data.rowsCount;


				this.isRateLimitReached = false;

			});
	}

	donationCategoriesDebitBalance = 0;

	private initForm() {
		this.searchDonationCategoriesListForm = this.formBuilder.group({
			page: [1],
			pageRows: [20],
			query: [],
			donationCategoryID: [],
			donationCategoryTitle: [],
		//	donationCategoryTypes: [],
			selectedRows: [],
			orders: this.formBuilder.array([])
		});
	}

	initUpdateCashRegisterModel(): FormGroup {
		return this.formBuilder.group({
			contactID: [, Validators.required],
			commitmentID: [, Validators.required],
			amount: [, Validators.required]
		});
	}


	panelOpenState;
	rows: any[];
	loadingIndicator: boolean;
	reorderable: boolean;

	ngOnInit() {
		this.initForm();
		let item = sessionStorage.getItem(this.router.url);
		if (item) {
			let frm = JSON.parse(sessionStorage.getItem(this.router.url) || "");
			this.searchDonationCategoriesListForm.patchValue(frm);
		}
		this.getDonationCategories();
	}

	pageChange(e) {
		this.searchDonationCategoriesListForm.controls['pageRows'].setValue(e.pageSize || 20);
		this.selectionChanged(e);
	}

	selectionChanged(e) {
		this.getDonationCategories();
	}


	sortData(e) {
		this.addOrder(e.active, e.direction != "asc");
		this.getDonationCategories();
	}
	public search() {
	}
	addOrder(propertyName: string, desc: boolean = false) {
		const ordersControl = <FormArray>this.searchDonationCategoriesListForm.controls['orders'];

		let ord = this.getOrder(propertyName);
		if (ord != null) {
			ord.controls["value"].setValue(desc);
		} else {
			ord = this.initOrder(propertyName, desc);
			ordersControl.push(ord);
		}
	}
	pageEvent: PageEvent;
	pageSizeOptions;
	setPageSizeOptions(setPageSizeOptionsInput: string) {
		this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
	}
	initOrder(propertyName: string, desc: boolean = false) {
		let propName = propertyName;
		let des = desc;
		return this.formBuilder.group({
			key: [propName],
			value: [des],
		});
	}

	getOrder(columnName: string): any {
		let lst = <FormArray>this.searchDonationCategoriesListForm.controls['orders'];
		if (lst == null) return null;

		for (var i = 0; i < lst.length; i++) {
			if ((<FormGroup>lst.controls[i]).controls["key"].value == columnName) {
				return lst.controls[i];
			}
		}
		return null;
	}

	orderType(columnName: string) {
		let order = this.getOrder(columnName);
		return order != null ? order.controls["value"].value : null;
	}
}
